import React from 'react';
// import TextField from 'material-ui/TextField';
import {InputText} from './InputText';
// import EyeIcon from 'material-ui/svg-icons/image/remove-red-eye';
import EyeIcon from 'images/passEye.svg';

export default class extends React.Component {
    state = {
        value : '',
        type: 'password',
        errorText : null
    };

    showPass =(e) => {
        e.currentTarget.classList.toggle('active');

        this.setState({
            type:
                this.state.type === 'password' ?  'text' : 'password'
            })
    };

    componentWillReceiveProps(newProps) {
        this.setState({value: newProps.value, errorText: newProps.errorText})
    }

    handleChange = e => {
       this.props.handleChange({target: {name: this.props.name, value: e.target.value}})
    };

    render(){
      const placeholder = this.props.placeholder || '';

        return (
            <div className="input-wrap pass-wrap">
                <InputText
                    name="password"
                    className='password'
                    value={this.state.value}
                    onChange={this.handleChange}
                    label={this.props.label}
                    placeholder={placeholder}
                    errorText={this.state.errorText}
                    type={this.state.type}
                />
                {this.state.value &&  <span className='icon-wrap'  onClick={this.showPass}>
                    <img src={EyeIcon} />
                    {/* <EyeIcon
                        className="eye-icon"
                    /> */}
                </span> }
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/modules/blocks/inputs/PasswordWrapper.js